<div class="time-filter">
  <span class="time-filter__label">From</span>
  <div class="time-filter__inputs">
    <mat-form-field appearance="outline">
      <mat-select name="hoursFrom"
        #hoursFrom
        placeholder="hh"
        [(ngModel)]="timeGroup.hoursFrom"
        (ngModelChange)="onFromHourChange()"
      >
        <mat-option *ngFor="let hour of hours" [value]="hour">
          {{hour}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-select name="minutesFrom"
        #minutesFrom
        placeholder="mm"
        [(ngModel)]="timeGroup.minutesFrom"
        (ngModelChange)="onFromMinuteChange()"
      >
        <mat-option *ngFor="let minute of minutes" [value]="minute">
          {{minute}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <span class="time-filter__label">To</span>
  <div class="time-filter__inputs">
    <mat-form-field appearance="outline">
      <mat-select name="hoursTo"
        #hoursTo
        placeholder="hh"
        [(ngModel)]="timeGroup.hoursTo"
        (ngModelChange)="onToHourChange($event)"
      >
        <mat-option *ngFor="let hour of hours" [value]="hour">
          {{hour}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-select name="minutesTo"
        #minutesTo
        placeholder="mm"
        [(ngModel)]="timeGroup.minutesTo"
        (ngModelChange)="onToMinuteChange()"
      >
        <mat-option *ngFor="let minute of minutes" [value]="minute">
          {{minute}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
